import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ScheduleView from '@/views/ScheduleView.vue'
import EmptyView from '@/views/EmptyView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: HomeView,
    redirect: '/middleware',
    children: [
      {
        path: '/middleware',
        component: () => import(/* webpackChunkName: "Middleware" */ '@/views/middleware.vue'),
      },
      {
        path: '/scheduling',
        redirect: '/scheduling/testInformation',
        component: ScheduleView,
        children: [
          // 隐私确认 global url
          {
            path: '/scheduling/agreement',
            meta: {
              title: 'Policy Agreement',
            },
            component: () => import(/* webpackChunkName: "PrivacyConfirm" */ '@/views/schedule/privacyConfirmGlobal.vue'),
          },
          // 完善信息 global url
          {
            path: '/scheduling/candidateProfile',
            meta: {
              title: 'Additional Demographic Information',
            },
            component: () => import(/* webpackChunkName: "PerfectInfo" */ '@/views/schedule/PerfectInfoGlobal.vue'),
          },
        ],
      },
      {
        path: '/scheduling/cancelappointment',
        redirect: '/scheduling/cancelappointment/verification',
        component: EmptyView,
        children: [
          // 资格码查询 global url
          {
            path: '/scheduling/appointmentsearch',
            meta: {
              title: 'Appointment Search',
            },
            component: () => import(/* webpackChunkName: "appointmentsearch" */ '@/views/schedule/eligibilityCodeSearchGlobal.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '*',
    meta: {
      needAuth: false,
      title: 'NotFound',
    },
    component: () => import(/* webpackChunkName: "NotFound" */ '@/views/404.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = 'ProScheduler - ' + to.meta.title
    if (to.meta.titleCustom === true) document.title = to.meta.title
  }
  next()
})

export default router
